'use strict';

import React, { Component } from 'react'

import { search } from '@root/utility'

import Layout   from '@Layout/ECFront'

import HolidaysMessage from '@/HolidaysMessage'

import SearchBar from '@Pure/SearchBar'
import Link      from '@Pure/Link'
import Image     from '@Pure/Image'
import Loader    from '@Pure/Loader'
import Logo      from '@Pure/Logo'

const { app, qwest } = window;

export default class FrontWebPartnersPage extends Component
{
	constructor (props)
	{
		super(props);

		this.state =
		{
			data: [],
			references: [],
			pagination:
			{
				max_items: 30,
				limit: 30,
				skip: 0
			},
			searched:
			{
				value: ''
			}
		};

		this.getPagination = this.getPagination.bind(this);
		this.handleSearch  = this.handleSearch.bind(this);
	}

	UNSAFE_componentWillMount ()
	{
		const component = this, props = this.props, config = this.props.config;

		app.resetFunctions();

		component.setState({ loading: true });

		qwest.post('/CMS/getAll',
		{
			model: 'partner',
			filter_query: JSON.stringify(
			{
				online_access: [true, 'true']
			})
		})
		.then(function (xhr, response)
		{
			let data = response.data;

			component.setState(
			{
				loading: false,
				data: data,
				references: response.references || []
			});
		})
		.catch(function (error, xhr, response)
		{
			app.ajaxRedirectLogin(response);

			console.error(error);
		});
	}

	getPagination ()
	{
		const component = this, props = this.props, config = this.props.config;

		let limit     = this.state.pagination.limit, skip = this.state.pagination.skip;
		let max_items = this.state.pagination.max_items;

		let total_items = component.state.data.length;

		let pagination = [];

		for (let i = 0; i < total_items; i += max_items)
		{
			let data =
			{
				items_count: (i + max_items > total_items) ? (total_items - i) : (max_items),
				skip: i
			};

			data.limit = i + data.items_count;

			pagination.push(data);
		}

		pagination = pagination.map(function (data, index)
		{
			let is_active = component.state.pagination.limit === data.limit;

			let output =
			(
				<div key={ index } className={ 'c-pagination-item' +
					(is_active ? ' c-pagination-item--active' : '') }
					onClick={ function () { setPagination(data); } }>
					{ index + 1 }
				</div>
			);

			return output;
		});

		return pagination;

		function setPagination (data)
		{
			let pagination = Object.assign({ }, component.state.pagination);

			pagination.limit = data.limit;
			pagination.skip  = data.skip;

			component.setState({ pagination: pagination });
		}
	}

	handleSearch (value, search)
	{
		const component = this, props = this.props;

		component.setState(
		{
			searched:
			{
				value: value,
				data: (search ? search.data : undefined)
			}
		});

		app.emit('searchChange');
	}

	render ()
	{
		const component = this, props = this.props, state = this.state;

		let loader;

		if (component.state.loading === true)
		{
			loader =
			(
				<Loader className="c-loader"
					bemit={ ['primary', 'bg-light', 'medium', 'Products'] } />
			);
		}

		let data = component.state.data;

		data
		.filter(partner => Boolean(partner.category))
		.forEach(function (partner)
		{
			let category = state.references
			.find(infos => infos.model === 'category')
			.data.find(category => category.id === partner.category);

			if (category)
			{
				partner._category = category.label;
			}
		});

		data
		.filter(partner => Boolean(partner.place))
		.forEach(function (partner)
		{
			let place = state.references
			.find(infos => infos.model === 'place')
			.data.find(place => place.id === partner.place);

			if (place)
			{
				partner._places = place.name;
			}
		});

		if (component.state.searched.value !== '')
		{
			data = data.filter(function (partner)
			{
				let matches = 0;

				['name', '_places', 'city']
				.forEach(function (field)
				{
					if (!partner[field]) return;

					matches += search(partner[field], component.state.searched.value);
				});

				partner.__search_matches = matches;

				return matches > 0;
			})
			.sort(function (a, b)
			{
				return a.__search_matches > b.__search_matches;
			});
		}
		else
		{
			data = data
			.sort(function (a, b)
			{
				return a.name.toLowerCase().localeCompare(b.name.toLowerCase());
			});
		}

		let partners = data
		.filter(function (element, index)
		{
			if (props.pagination === false)
			{
				return true;
			}

			return index < state.pagination.limit && index >= state.pagination.skip;
		})
		.map(function (partner, key)
		{
			var category, place;

			if (partner._category)
			{
				category =
				(
					<div className="c-model-preview__themes">
						<div className="c-model-preview__theme">
							{ partner._category }
						</div>
					</div>
				);
			}

			if (partner._places)
			{
				place =
				(
					<div className="c-model-preview__places">
						<svg className="o-svg-icon o-svg-icon--tracker c-model-preview__places-icon">
							<use xlinkHref="/images/icons.svg#svg-icon-tracker"></use>
						</svg>
						{ partner._places }
					</div>
				);
			}
			else if (partner.city)
			{
				place =
				(
					<div className="c-model-preview__places">
						<svg className="o-svg-icon o-svg-icon--tracker c-model-preview__places-icon">
							<use xlinkHref="/images/icons.svg#svg-icon-tracker"></use>
						</svg>
						{ partner.city }
					</div>
				);
			}


			let short_description = partner.discount_infos.split('<br>').join('');
			short_description = short_description.split('<p></p>').join('');

			short_description =
			(
				<span className="c-rendered-text" dangerouslySetInnerHTML={
					{ __html: app.truncateToLength(short_description, 130, '') } } />
			);

			let thumbnail = partner.logo?.[0]?.url;

			if (!thumbnail) thumbnail = partner.images?.[0]?.url;

			if (thumbnail)
			{
				thumbnail =
				(
					<Image className="c-model-preview__img" src={ thumbnail } />
				);
			}
			else
			{
				thumbnail =
				(
					<Logo className="c-model-preview__img default" type="svg"
						synergies={ true } />
				);
			}

			let displayed_name = partner.name;

			if (partner.city)
			{
				displayed_name += ' (' + partner.city + ')';
			}

			let output =
			(
				<div className="c-model-preview-item partner o-grid__item u-flex"
					key={ partner.id + key }>

					<div className="c-model-preview c-model-preview--partner">
						<div className="c-model-preview__thumb">
							<Link className="c-model-preview__thumb-link"
								href={ '/accueil/offres-web/' + partner.id }>
								{ thumbnail }
							</Link>
						</div>

						<h2 className="c-model-preview__title">
							<Link href={ '/accueil/offres-web/' + partner.id }
								className="c-model-preview__title-link">
								{ displayed_name }
							</Link>
						</h2>

						{ category }

						<div className="c-model-preview__infos">

							<div className="c-model-preview__description">
								{ short_description }
							</div>

							{ place }

							<div className="c-model-preview__buttons">
								<Link href={ '/accueil/offres-web/' + partner.id }
									className="c-model-preview__link">
									<svg className="o-svg-icon o-svg-icon--eye c-model-preview__link-icon">
										<use xlinkHref="/images/icons.svg#svg-icon-eye"></use>
									</svg>Fiche partenaire
								</Link>
							</div>

						</div>
					</div>

				</div>
			);

			return output;
		});

		let pagination = component.getPagination();

		if (pagination)
		{
			if (pagination.length <= 1 || state.searched.value !== '')
			{
				pagination = undefined;
			}
		}

		var output =
		(
			<Layout history={ props.history } page_title="Partenaires en ligne">

				<div className="page-content">

					<HolidaysMessage />

					<div className="o-content">

						<div className="c-title u-no-margin-top">
							<h2 className="c-title__txt">Partenaires en ligne</h2>
						</div>

						<div className="front-dashboard-search">
							<SearchBar className="c-searchbar c-searchbar--front"
								hide_btn={ true } placeholder="Recherche..." data={ [] }
								handleChange={ component.handleSearch }
								value={ component.state.searched.value }
							/>
						</div>

						<div className="c-pagination u-margin-bottom-15">
							{ pagination }
						</div>

						<div className="u-negative-margin">

							<div className="o-grid-4 u-flex">
								{ loader || partners }
							</div>

						</div>

						<div className="c-pagination u-margin-top-15">
							{ pagination }
						</div>

					</div>

				</div> { /* /page-content */ }

			</Layout>
		);

		return output;
	}
}